/**
 * Minimal SSE frame handling for fetch-streamed event sources.
 * We stream via fetch (not EventSource) because the API wants the
 * `Authorization: Bearer` header, which EventSource cannot send.
 */

/** Split accumulated stream text into complete event blocks + unconsumed tail. */
export function splitSseEvents(buffer: string): { events: string[]; rest: string } {
  // ponytail: CR normalized to LF up front; a lone CR at a chunk boundary can
  // produce one empty block, which the trim filter below discards.
  const normalized = buffer.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  const parts = normalized.split('\n\n');
  const rest = parts.pop() ?? '';
  return { events: parts.filter((p) => p.trim() !== ''), rest };
}

/** Extract joined `data:` payload from one event block; null if none. */
export function sseEventData(block: string): string | null {
  const data: string[] = [];
  for (const line of block.split('\n')) {
    if (line.startsWith('data:')) data.push(line.slice(5).trimStart());
  }
  return data.length > 0 ? data.join('\n') : null;
}
